import { Link } from "react-router-dom";
import HeroImage from "../assets/undraw_reading_time.svg";

const Home = () => {
  return (
    <main className="w-full h-full lg:flex lg:mt-16">
      <div className="p-12 md:w-3/4 md:m-auto lg:w-2/5">
        <img src={HeroImage} alt="hero" />
      </div>

      <div className="md:w-3/4 md:m-auto lg:w-1/3 lg:mx-16 text-sub mx-5 home_description text-center bg-card rounded-lg p-4  mb-6 border-solid border-2 border-sub">
        <h1 className="text-xl font-bold mb-4">Welcome to Quote Maker</h1>
        <p className="mb-8">
          Capture and share your favorite quotes. Create stunning quote images
          and download them with ease.
        </p>
        <Link
          to={"/profile"}
          className="block mt-4 px-4 py-2 font-medium rounded-lg border-solid border-2 border-sub bg-deco hover:shadow-xl"
        >
          Get Started
        </Link>
      </div>
    </main>
  );
};

export default Home;
